import { render, staticRenderFns } from "./OvFaq.vue?vue&type=template&id=2e83e9b6"
import script from "./OvFaq.vue?vue&type=script&lang=js"
export * from "./OvFaq.vue?vue&type=script&lang=js"
import style0 from "./OvFaq.vue?vue&type=style&index=0&id=2e83e9b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports